import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'

const getInitialState = () => ({
  ...storePagination.state(),
  productDepartments: [],
  filters: { name: '' },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_PRODUCT_DEPARTMENTS(state, productDepartments) {
      state.productDepartments = productDepartments
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, productDepartments } = getInitialState()
      state.filters = filters
      state.productDepartments = productDepartments
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchProductDepartments({ commit, state }) {
      const { data } = await axios.get('/api/departments', {
        params: {
          name: state.filters.name ? state.filters.name : '',
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
          sortBy: sorting.methods.getSorting(state)
        },
      })

      commit('SET_PRODUCT_DEPARTMENTS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })
    },

    setFilter({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
